// extracted by mini-css-extract-plugin
module.exports = {"closeAlertButton":"EGiftCard_closeAlertButton__3BTqI","imageUploader":"EGiftCard_imageUploader__VEG8I"};